import { api } from './api';

export const contactsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getContacts: build.query({
      query: () => ({
        url: "contacts",
        method: "GET",
      }),
      transformResponse: (response, meta, arg) => {
        return response.data
      },
      providesTags: (result) => [{ type: 'Contacts', id: 'LIST' }]
    }),
    getContactsWithPagination: build.query({
      query: (
        query = {
          skip:0,
          limit: 40,
          filter: {text: ''},
        },
      ) => ({
        url: "contacts",
        method: "POST",
        body: JSON.stringify(query)
      }) ,
      providesTags: (result) => {
        return result.data ?
          [ ...result.data.records.map(({ model}) => ({ type: 'Contacts', id: model.ID })),
            { type: 'Contacts', id: 'LIST' },
          ]
          :
          [{ type: 'Contacts', id: 'LIST' }]

      }
    }),
    getContact: build.query({
      query: (id) => ({
        url: `contact/${id}`,
      }),
      providesTags: (_result, _err, id) => [{ type: 'Contacts', id }],
    }),
    updateContact: build.mutation({
      query: ({id, form}) => ({
        url: `contact/${id}`,
        method: 'PUT',
        body: JSON.stringify({...form}),
      }),
      invalidatesTags: (result, error) => {
        return error ? [] : [{ type: 'Contacts', id: 'LIST' }]
      },
    }),
    createContact: build.mutation({
      query: (form) => ({
        url: 'contact',
        method: 'POST',
        body: JSON.stringify({...form}),
      }),
      invalidatesTags: (result, error) => error ? [] : [{ type: 'Contacts', id: 'LIST' }],
    }),
    deleteContact: build.mutation({
      query: (id) => ({
        url: `contact/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error) => error ? [] : [{ type: 'Contacts', id: 'LIST' }],
    }),
  }),
});


export const {
  useGetContactsQuery,
  useGetContactsWithPaginationQuery,
  useLazyGetContactsQuery,
  useGetContactQuery,
  useLazyGetContactQuery,
  useCreateContactMutation,
  useUpdateContactMutation,
  useDeleteContactMutation,
} = contactsApi;
